<template>
	<div class="c-script-start">
		<h3>AI Scripts</h3>
		<article class="article-text-sm">
			<p>Turn saved ads into ad concepts, video scripts and more.</p>
			<p>
				<strong> How does it work? </strong>
			</p>
			<ol>
				<li>Choose what to generate: video script, ad concept, etc.</li>
				<li>Pick a reference ad from your library if needed.</li>
				<li>Add your brand brief for context if needed.</li>
				<li>Get your script instantly!</li>
			</ol>
			<div class="text-center">
				<button type="button" class="btn btn-primary btn-box" @click="next">
					<span> Start </span>
				</button>
			</div>
		</article>
	</div>
</template>

<script>
export default {
	methods: {
		next: function () {
			this.$emit('next');
		},
	},
};
</script>

<style lang="scss">
.c-script-start {
	margin: 0 auto;
	width: var(--page-width);
	background-color: var(--color-bg-1);
	padding: 1rem;
	border-radius: 0.5rem;
	border: var(--color-bg-3) solid 1px;

	h3 {
		text-align: center;
		margin-bottom: 1rem;
	}

	.btn {
		width: 100%;
	}
}
</style>
